import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { ProviderJackpot, ProvidersJackpotsState } from './types'

const initialState: ProvidersJackpotsState = {
  isLoaded: false,
  jackpots: [],
}

export const jackpotsFromProvidersSlice = createSlice({
  name: 'providersJackpots',
  initialState,
  reducers: {
    setJackpotsData: (state, action: PayloadAction<ProviderJackpot[]>) => {
      state.jackpots = action.payload
      state.isLoaded = true
    },
  },
})

export const { actions } = jackpotsFromProvidersSlice
